<template lang="pug">
  main
    transition(name="fade" mode="out-in")
      router-view
    ModalLogs
    #dialogdk.dialogdk
      section#dialogdkbox
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalLogs from "./views/components/ModalLogs.vue";

export default {
  name: "App",

  components: {
    ModalLogs
  },

  created() {
    this.startup();
    document.addEventListener("visibilitychange", () =>
      this.setViewState(document.visibilityState === "visible")
    );
  },

  computed: {
    ...mapState(["sessionMaster"])
  },

  methods: {
    ...mapActions(["setViewState", "startup"])
  }
};
</script>
<style lang="scss">
$gutterSm: 0.4rem;
$gutterMd: 0.8rem;
$gutterLg: 1rem;
$gutterXl: 2.4rem;
$gutterXx: 7.2rem;
$colorPrimary400: #c4e3fa;
$colorPrimary600: #94cffd;
$colorPrimary800: #7bc6ff;
$fontFamily: "Dosis", sans-serif;
$fontSizeSm: 1.2rem;
$fontSizeMd: 1.6rem;
$fontSizeLg: 2.1rem;
$fontSizeXl: 2.8rem;
$fontSizeXx: 3.6rem;
$lineHeightSm: 1.1;
$lineHeightMd: 1.8;
$transitionDuration: 300ms;
$transitionTF: cubic-bezier(0.645, 0.045, 0.355, 1);

$inputPaddingV: $gutterMd;
$inputPaddingH: $gutterLg;
$inputFontSize: $fontSizeLg;
$inputLineHeight: $lineHeightMd;
$labelScaleFactor: 0.8;
$labelDefaultPosY: 50%;
$labelTransformedPosY: calc(50% - (0.8rem * 0.8) - (2.1rem * 1.8));
$inputTransitionDuration: $transitionDuration;
$inputTransitionTF: $transitionTF;

:root {
  --color-primary: #055ba4;
  --font-primary: "Red Hat Display";
}

body {
  height: stretch;
}

.bolder {
  font-weight: bold !important;
}

.dialogdk {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  display: none;
  bottom: 0;
}
.dialogdk section {
  position: fixed;
  left: 50%;
  top: 30px;
  transform: translate(-50%, -50%);
  background-color: rgb(255, 255, 255);
  display: none;
  color: rgb(26, 26, 26);
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 10px;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.11);
  border-radius: 5px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.dialogdk p {
  margin: 0;
}

.Input {
  position: relative;
}

.Input-text {
  display: block !important;
  margin: 0 !important;
  padding: 0 $inputPaddingH !important;
  color: rgb(0, 0, 0) !important;
  width: 100% !important;
  font-weight: 400 !important;
  line-height: $inputLineHeight !important;
  border: none !important;
  border-radius: 10px !important;
  transition: box-shadow $transitionDuration !important;
  box-shadow: 0rem 0rem 0.1rem rgb(218, 217, 217);
  min-height: 40px;
  font-size: 1.25rem !important;
  background-color: white !important;
  border: 1px solid #9e9ea0 !important;
}

.Input-text.select {
  background: url("./assets/arrow-up-icon-23.png") no-repeat;
}

.Input-text:focus {
  outline: none;
  box-shadow: 0rem 0rem 0.5rem $colorPrimary600;
}

.Input-text::placeholder {
  color: rgba(128, 128, 128, 0.582) !important;
}

.dk-overlay {
  background-color: rgb(255 255 255 / 82%);
  position: relative;
  padding: 1rem;
  border: 2px solid #c7c7c7;
  border-radius: 5px;
}

.Input-label {
  display: block;
  position: absolute;
  bottom: 50%;
  left: 1rem;
  color: #fff;
  font-family: inherit;
  font-size: $inputFontSize;
  font-weight: inherit;
  line-height: $inputLineHeight;
  opacity: 0;
  transform: translate3d(0, $labelDefaultPosY), 0 scale(1);
  transform-origin: 0 0;
  transition: opacity $inputTransitionDuration $inputTransitionTF,
    transform $inputTransitionDuration $inputTransitionTF,
    visibility 0ms $inputTransitionDuration $inputTransitionTF,
    z-index 0ms $inputTransitionDuration $inputTransitionTF;
}

.Input-text:placeholder-shown + .Input-label {
  visibility: hidden;
  z-index: -1;
}

.Input-text:not(:placeholder-shown) + .Input-label,
.Input-text:focus:not(:placeholder-shown) + .Input-label {
  visibility: visible;
  z-index: 1;
  opacity: 1;
  transform: translate3d(0, $labelTransformedPosY, 0) scale($labelScaleFactor);
  transition: transform $inputTransitionDuration, visibility 0ms, z-index 0ms;
}

* {
  font-family: var(--font-primary);
}

.modal-content {
  border-radius: 15px !important;
}

.text-start {
  text-align: start !important;
}

body {
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
}

html {
  min-height: 100%;
}

/* @keyframes changeImageDKDK {
  0% {
    background: url(./loading-buffering.gif);
  }
  100% {
    background: url(./checkmark.png);
  }
} */
</style>
